import Burgundy1 from "../../../media/burgundy/burgundy1.png";
import Burgundy2 from "../../../media/burgundy/burgundy2.png";
import Burgundy3 from "../../../media/burgundy/burgundy3.png";
import Burgundy4 from "../../../media/burgundy/burgundy4.png";

const burgundyimages = [Burgundy1, Burgundy2, Burgundy3, Burgundy4];

export default burgundyimages;
